// import { EntrepreneurAnnounce10InnovationFormComponent } from "../../../components/SupportSystem/SupportForm/EntrepreneurAnnounce10InnovationFormComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { DetailInnovationCourseComponent } from "../../../components/SupportSystem/SupportForm/current/DetailInnovationCourseComponent";

export function DetailInnovationCourseContainer () {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <DetailInnovationCourseComponent />
            <Footer />
        </div>        
    )
    
}